export const queryListUserCacheKey = 'master-user';
export const queryListRoleCacheKey = 'master-role';
export const queryListLayoutCacheKey = 'master-layout';
export const queryRoleMappingCacheKey = 'role-function-mapping';